export default "__VITE_ASSET__BEGlAJOP__"